var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.625C7.35837 10.625 5.20837 8.47496 5.20837 5.83329C5.20837 3.19163 7.35837 1.04163 10 1.04163C12.6417 1.04163 14.7917 3.19163 14.7917 5.83329C14.7917 8.47496 12.6417 10.625 10 10.625ZM10 2.29163C8.05004 2.29163 6.45837 3.88329 6.45837 5.83329C6.45837 7.78329 8.05004 9.37496 10 9.37496C11.95 9.37496 13.5417 7.78329 13.5417 5.83329C13.5417 3.88329 11.95 2.29163 10 2.29163Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1584 18.9583C16.8167 18.9583 16.5334 18.675 16.5334 18.3333C16.5334 15.4583 13.6002 13.125 10.0002 13.125C6.40012 13.125 3.4668 15.4583 3.4668 18.3333C3.4668 18.675 3.18346 18.9583 2.8418 18.9583C2.50013 18.9583 2.2168 18.675 2.2168 18.3333C2.2168 14.775 5.70846 11.875 10.0002 11.875C14.2918 11.875 17.7834 14.775 17.7834 18.3333C17.7834 18.675 17.5001 18.9583 17.1584 18.9583Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.19c17c42afbc7f7cbba12a40e2346a3e.svg";
export { ForwardRef as ReactComponent };